import { Stack } from 'expo-router';

export default function ProgramDetailLayout() {
  return (
    <Stack>
      <Stack.Screen name="[programId]" />
    </Stack>
  );
}
